import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderCard = ({ 
  folio, 
  cliente, 
  vehiculo, 
  total, 
  estado, 
  fecha,
  onClick 
}) => {
  const statusConfig = {
    'Cotizada': { 
      color: 'bg-blue-100 text-blue-700 border-blue-200',
      icon: 'FileText'
    },
    'Aprobada': { 
      color: 'bg-green-100 text-green-700 border-green-200',
      icon: 'CheckCircle'
    },
    'En proceso': { 
      color: 'bg-yellow-100 text-yellow-700 border-yellow-200',
      icon: 'Clock'
    },
    'Lista': { 
      color: 'bg-purple-100 text-purple-700 border-purple-200',
      icon: 'Package'
    },
    'Entregada': { 
      color: 'bg-emerald-100 text-emerald-700 border-emerald-200',
      icon: 'CheckCircle2'
    },
    'Cancelada': { 
      color: 'bg-red-100 text-red-700 border-red-200',
      icon: 'XCircle'
    }
  };

  const config = statusConfig?.[estado] || statusConfig?.['Cotizada'];

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleKeyDown = (e) => {
    if (e?.key === 'Enter' || e?.key === ' ') {
      e?.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className="bg-card rounded-lg p-4 border border-border shadow-elevation-1 hover:shadow-elevation-2 transition-smooth cursor-pointer hover:-translate-y-px"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 mb-1">
            <span className="text-sm font-semibold text-foreground">
              #{folio}
            </span>
            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${config?.color}`}>
              <Icon name={config?.icon} size={12} className="mr-1" />
              {estado}
            </span>
          </div>
          <p className="text-sm text-muted-foreground truncate">
            {cliente}
          </p>
        </div>
      </div>
      <div className="space-y-2">
        <div className="flex items-center text-xs md:text-sm text-muted-foreground">
          <Icon name="Car" size={14} className="mr-2 flex-shrink-0" />
          <span className="truncate">{vehiculo}</span>
        </div>
        
        <div className="flex items-center justify-between pt-2 border-t border-border">
          <div className="flex items-center text-xs text-muted-foreground">
            <Icon name="Calendar" size={14} className="mr-1" />
            <span>{fecha}</span>
          </div>
          <span className="text-sm md:text-base font-bold text-foreground whitespace-nowrap">
            ${total?.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrderCard;